import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Container, Image, HeaderTitle, SubHeaderTitle, ContainerHeader, SubContainerButton, SubContainerField, ContainerImage, ContainerFieldLocation, ContainerContent } from './style'
import InputPassword from '../../components/InputPassword/InputPassword'
import Button from '../../components/Button/Button'
import logo from '../../assets/images/logo.png'
import disableBrowserBackButton from 'disable-browser-back-navigation'
import ModalAlert from '../../components/ModalAlert/ModalAlert'
import { checkGeolocation } from '../../helpers/geo'
import CurrentTime from '../../components/CurrentTime/CurrentTime'
import { fetchAtualizarSenhaStart, atualizarSenhaReset }  from '../../services/store/reducers/endpoints/atualizarSenha'
import { fetchRegistrarInfoStart } from '../../services/store/reducers/endpoints/registrarinfo'

class UpdatePassword extends PureComponent{
  
  state = {
    senha: '',
    senhaReadOnly: true,
    confirmarSenha: '',
    sended: false,
    routeBack: '/register-point'
  }

  constructor(props) {
    super(props);
    this.confirmarSenhaInput = React.createRef()
  }

  UNSAFE_componentWillMount () { 
    console.log('----', this.props.home.company)
    console.log('----------->', this.props.configuration)
    let routeBack = this.props.location.search
    routeBack = routeBack.split('?routeBack=')[1]
    routeBack = '/' + routeBack.split('&')[0]
    this.setState({routeBack: routeBack})
    disableBrowserBackButton()
  }

  confirmar = () => {
    //const { routeBack } = this.props.match.params
    this.props.atualizarSenhaReset()
    this.setState({sended: true})
    if(this.state.senha === '') {
      this.setState({titleModal: 'Atenção!', messageModal: 'Senha obrigatória!'})
      return
    }
    if (this.state.senha.length < this.props.appConfig.tamanhoMinimoSenha) {
        this.setState({
            titleModal: 'Atenção!',
            messageModal: `A senha deve conter no mínimo ${this.props.appConfig.tamanhoMinimoSenha} caracteres.`,
        });
        return false;
    }
    if (this.state.senha.length > this.props.appConfig.tamanhoMaximoSenha) {
        this.setState({ 
            titleModal: 'Atenção!',
            messageModal: `A senha deve conter no máximo ${this.props.appConfig.tamanhoMaximoSenha} caracteres.`,
        });
        return false;
    }
    if( this.state.confirmarSenha === ''){
      this.setState({titleModal: 'Atenção!', messageModal: 'Confirmar senha!'})
      return
    }
    if(this.state.confirmarSenha !==  this.state.senha){
      this.setState({titleModal: 'Atenção!', messageModal: 'Os dados não coincidem!'})
      return
    }

    //internet
    if (!window.navigator.onLine) {
      window.location.href='/report-user?message=-&errorCode=1'
      return
    }
    //location
    checkGeolocation().then((result) => {
      if(result){
        this.props.fetchAtualizarSenhaStart({
          token: this.props.token, 
          re: this.props.registerPoint.re,
          NovaSenha: this.state.senha,
          Empresa: this.props.home.company
        })
      }else{
        this.props.fetchRegistrarInfoStart({          
          "RE": this.props.registerPoint.re,
          "Empresa": this.props.home.company,
          "Cliente": this.props.registerPoint.codCliente,
          "Unidade": this.props.registerPoint.codUnidade,
          "Detalhes": "Usuário não está com GPS habilitado."
        })
        window.location.href='/report-user?message=Você não esta com gps&errorCode=2'
      }
    })
  }

  resposta = () => {

    this.setState({sended: false})
    let result = this.props.sagaAtualizarSenha
    if(result === 'Senha alterada com sucesso!'){
      
      this.setState({titleModal: 'Sucesso', messageModal: result})
    }else{
      this.setState({titleModal: 'Atenção!', messageModal: 'Algo deu errado ao alterar sua senha, por favor entre em contato com o seu supervisor.'})
      
    }
  }

  cancelar = () => {
    window.location.href = this.state.routeBack
  }

  handleKeyPressSenha = (event) => {
    
    if(event.key === 'Enter'){
      this.confirmarSenhaInput.current.focus();
    }
  }

  handleKeyPressConfirmarSenha = (event) => {
    
    if(event.key === 'Enter'){
      this.confirmar()
    }
  }

 
  render() {

    const { sagaAtualizarSenha } = this.props
    
    return (
      <Container>
        <ContainerImage>
          <Image src={logo} />
        </ContainerImage>
        <CurrentTime></CurrentTime>
        <ContainerHeader>
          <HeaderTitle>Redefinição de senha</HeaderTitle>
          <SubHeaderTitle>Escolha uma nova senha</SubHeaderTitle>
        </ContainerHeader>

        
        
        <ContainerContent>

    <ContainerFieldLocation>
      <SubContainerField>
        <InputPassword type='text' 
        autoComplete={"off"} 
        readOnly={ this.state.senhaReadOnly }
        onFocus={ this.setState({senhaReadOnly: false}) }
        onKeyPress={(event) => { this.handleKeyPressSenha(event)}}
        onChange={(event) => { 
          this.setState({senha: event.target.value})
        }}
        value={this.state.senha}
        name='oldPassword' placeholder='Nova senha' />
      </SubContainerField>
    </ContainerFieldLocation>
    <ContainerFieldLocation>
      <SubContainerField>
        <InputPassword type='text' 
        autoComplete={"off"} 
        readOnly={ this.state.senhaReadOnly }
        onFocus={ this.setState({senhaReadOnly: false}) }
        ref={this.confirmarSenhaInput}
        onKeyPress={(event) => { this.handleKeyPressConfirmarSenha(event)}}
        onChange={(event) => { this.setState({confirmarSenha: event.target.value}) }}
        name='oldPassword' placeholder='Confirmação da nova senha'  />
      </SubContainerField>
    </ContainerFieldLocation>
   </ContainerContent>
      
        <SubContainerButton>
          <Button width='130px' backgroundColor='#40bbca' onClick={() => { this.cancelar() }}>Cancelar</Button>
          <Button width='130px'  backgroundColor='#40bbca' onClick={() => { this.confirmar() }} >Confirmar</Button>
        </SubContainerButton>

        {
          sagaAtualizarSenha &&
          this.state.sended &&
          this.resposta()
        }

        {
          //para colocar os pop up
          this.state.titleModal && 
          this.state.messageModal &&
          this.state.titleModal.length > 0 &&
          this.state.messageModal.length > 0 &&
          <ModalAlert 
            title={this.state.titleModal} 
            message={ this.state.messageModal} 
            onClick={() => { 
              this.setState({messageModal: '', titleModal: ''})
              if(sagaAtualizarSenha){
                window.location.href = this.state.routeBack
              }
             } }
            />
        }    

     </Container>
    )
  }
}


const mapStateToProps = state => ({
  registerPoint: state.registerPoint,
  token: state.token.token,
  configuration: state.configuration,
  home: state.home,
  sagaAtualizarSenha: state.sagaAtualizarSenha.data,
  appConfig: state.appConfig
})

const mapDispatchToProps = dispatch => ({
  fetchRegistrarInfoStart: (value) => dispatch(fetchRegistrarInfoStart(value)),
  fetchAtualizarSenhaStart: (mss) => dispatch(fetchAtualizarSenhaStart(mss)),
  atualizarSenhaReset: () => dispatch(atualizarSenhaReset())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdatePassword)